/**
 * Similar to the range() function in Python, but without the optional step
 * parameter. The direction of iteration is determined automatically. Note that
 * range(3, 0) is not the reverse of range(0, 3) because the first parameter
 * is always inclusive, and the second parameter is always exclusive.
 */



export function* range(start: number, end: number) {
    if (start > end) {
        for (let i = start; i > end; i--) {
            yield i;
        }
    } else {
        for (let i = start; i < end; i++) {
            yield i;
        }
    }
}
